const CATEGORIES = [
  {
    img: 'https://images.unsplash.com/photo-1489944440615-453fc2b6a9a9?w=600&q=80',
    icon: 'ri-football-line',
    iconColor: 'from-emerald-500 to-teal-600',
    title: '⚽ Sports en Direct',
    desc: 'Tous les matchs de foot, tennis, boxe, F1 — BeIN, Canal+, DAZN et plus encore.',
    large: true,
  },
  {
    img: 'https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=600&q=80',
    icon: 'ri-movie-2-line',
    iconColor: 'from-purple-500 to-pink-600',
    title: '🎬 Films & Cinéma',
    desc: 'Des milliers de films en 4K — blockbusters, classiques, et nouveautés chaque semaine.',
  },
  {
    img: 'https://images.unsplash.com/photo-1522869635100-9f4c5e86aa37?w=600&q=80',
    icon: 'ri-tv-line',
    iconColor: 'from-purple-500 to-fuchsia-600',
    title: '📺 Séries & VOD',
    desc: 'Netflix, Disney+, Prime Video et plus — toutes vos séries préférées en un seul endroit.',
  },
  {
    img: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&q=80',
    icon: 'ri-global-line',
    iconColor: 'from-cyan-500 to-blue-600',
    title: '🌍 Chaînes Internationales',
    desc: 'Plus de 150 pays couverts — chaînes arabes, européennes, africaines, américaines.',
  },
  {
    img: 'https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?w=600&q=80',
    icon: 'ri-bear-smile-line',
    iconColor: 'from-amber-400 to-orange-500',
    title: '👶 Contenu Enfants',
    desc: 'Des centaines de chaînes et dessins animés pour vos enfants — en toute sécurité.',
  },
];

export default function ContentCatalog() {
  return (
    <section className="py-12 sm:py-16 md:py-20 bg-gray-950 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute top-0 left-1/3 w-96 h-96 bg-primary rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/3 w-96 h-96 bg-[#862ce0] rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-10 sm:mb-14">
          <div className="inline-flex items-center gap-2 bg-primary/10 border border-primary/20 rounded-full px-4 py-2 mb-4 sm:mb-6">
            <span className="text-sm font-medium text-primary">Catalogue</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4 text-foreground">
            Sports, Films, Séries <span className="text-gradient">&amp; bien plus</span>
          </h2>
          <p className="text-muted-foreground text-base sm:text-lg max-w-2xl mx-auto">
            Un catalogue complet pour toute la famille — du sport en direct au divertissement illimité.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 max-w-6xl mx-auto">
          {CATEGORIES.map(({ img, icon, iconColor, title, desc, large }) => (
            <div
              key={title}
              className={`group relative rounded-2xl overflow-hidden aspect-[4/3] ${large ? 'sm:col-span-2 lg:col-span-1' : ''}`}
            >
              <img
                src={img}
                alt={title}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/20" />
              <div className="absolute bottom-0 left-0 right-0 p-5 sm:p-6">
                <div className={`w-10 h-10 rounded-xl bg-gradient-to-br ${iconColor} flex items-center justify-center mb-3`}>
                  <i className={`${icon} text-white`} />
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-white mb-1">{title}</h3>
                <p className="text-sm text-gray-300 leading-relaxed">{desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}